module.exports = __webpack_public_path__ + "img/shopping_application_4.3620ff92.jpg";